import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getListDownloadHistory, getListUpdateHistory } from "../../services/historyService";

const initialState = {
      filter: {
            status: null,
            type: null
      },
      sort: {
            sort_by: 'created_at',
            sort: 'desc'
      },
      feedbackSelected: undefined
};

export const historySlice = createSlice({
      name: "history",
      initialState,
      reducers: {
            changeFilter: (state, action: any) =>
            {
                  state.filter = action.payload;
            },

            changeSort: (state, action: any) =>
            {
                  state.sort = action.payload;
            },

            reset: (state) =>
            {
                  state.sort.sort = 'desc';
                  state.sort.sort_by = 'created_at';
                  state.filter.status = null;
                  state.filter.type = null

            },
            changeFeedbackSelected: (state, action: any) =>
            {
                  state.feedbackSelected = action.payload;
            },
      },
});

export const getListUpdateHistoryAsync = createAsyncThunk(
      "history/getListUpdateHistory",
      async (payload: any) =>
      {
            try
            {

                  const response = await getListUpdateHistory(payload);
                  return response;
            } catch (e: any)
            {
                  console.log(e, "error");

                  return {
                        message: e?.response?.data?.message,
                  };
            }
      }
);

export const getListDownloadHistoryAsync = createAsyncThunk(
      "history/getListDownloadHistory",
      async (payload: any) =>
      {
            try
            {

                  const response = await getListDownloadHistory(payload);
                  return response;
            } catch (e: any)
            {
                  console.log(e, "error");

                  return {
                        message: e?.response?.data?.message,
                  };
            }
      }
);

export const {
      changeFilter,
      changeSort,
      reset,
      changeFeedbackSelected
} = historySlice.actions;

export default historySlice.reducer;
